import { _get, decodeUrl, encodeUrl, getRandomId, getSingleAsync, showToast, showToastAsync } from "@utils/utils";
import { areaCityData } from "@server/areaApi";
import { commonConfig } from "@server/commonApi";
import { reportReportOnline } from "@server/report";
import { isLogin, redirect2Login } from "@utils/user";
import { sessionStorage, storage } from "@utils/storage";
import { useAppConfigStore } from "@/store/appConfig";
import pinia from "@/store/pinia";
import { router } from "@/router";
import config from "@/config";
import { getLocationWhenHasPermission } from "@utils/location";
import { clientParamData } from "@server/client";
import { getCurrPageQuery, getCurrPageRoute } from "@utils/route";
import appBridge from "@utils/appBridge";
import { useUserInfoStore } from "@/store/userInfo";
import { appointApply, appointCancelApply } from "@server/appoint";

const userInfoStore = useUserInfoStore(pinia);
const appConfigStore = useAppConfigStore(pinia);
/**
 * 获取服务供应商
 * @returns {Promise<string>} - 返回服务供应商字符串，如果失败返回 null
 */
export const getProvider = () => {
    return new Promise(resolve => {
        uni.getProvider({
            service: 'oauth',
            success: (res) => {
                resolve(_get(res, 'provider.0', null))
            },
            fail: () => {
                resolve(null)
            }
        });
    })
}

/**
 * 打开隐私协议
 */
export const openPrivacyContract = () => {
    wx.openPrivacyContract()
}

/**
 * 是否展示隐私协议
 * @returns {Promise<Boolean>}
 */
export const isShowPrivacy = () => {
    return new Promise(resolve => {
        uni.getPrivacySetting && uni.getPrivacySetting({
            success: (res) => {
                if (res.needAuthorization) {
                    return resolve(true)
                }
                resolve(false)
            },
            fail: () => {
                resolve(false)
            }
        })
    })
}

/**
 * 删除省市区汉字
 * @param str
 * @param deleteArray
 * @returns {*}
 */
export const deleteStr = (str, deleteArray = ['省', '市', '自治区', '特别行政区']) => {
    deleteArray.forEach(key => {
        str = str.replaceAll(key, '')
    })
    return str;
}

/**
 * 拼接省市
 * @param province
 * @param city
 * @returns {*|string}
 */
export const formatProvinceAndCity = (province, city) => {
    return province === city ? city : `${province}${city}`;
}

let _areaCityData = null;
export const getAreaCityData = async (refresh) => {
    if (_areaCityData && !refresh) {
        return { $success: true, data: _areaCityData };
    }
    const res = await areaCityData();
    if (res.$success) {
        let cityMap = {};
        res.data.cityList.forEach(c => {
            cityMap[c.code] = c;
        })
        res.data.cityMap = cityMap;
        _areaCityData = res.data;
        return res;
    }
    return { $success: false, msg: '网络异常~' }
}

/**
 * 获取app公共配置
 * @type {(function(*): Promise<*>)|*}
 */
export const getCommonConfig = getSingleAsync(async () => {
    const res = await commonConfig();
    if (res.$success) {
        appConfigStore.setAppConfig(res.data)
        return res.data
    }
})

/**
 * 上报用户在线
 * @returns {Promise<void>}
 */
export const initReportOnline = async () => {
    const run = () => {
        isLogin() && reportReportOnline()
    }
    run();
    const _config = await getCommonConfig();
    if (!_config) return
    setInterval(() => {
        run();
    }, _config.onlinePeriod * 1000)
}

/**
 * 设置数据到本地DB
 * @param data
 */
export const setDb = (data) => {
    const id = getRandomId();
    sessionStorage.set(id, data);
    return id;
}

/**
 * 从本地DB获取数据通过id
 * @returns {Promise<*>}
 */
export const getDbById = (id) => {
    return sessionStorage.get(id);
}

/**
 * 根据id清空本地DB数据
 * @param id
 * @returns {Promise<void>}
 */
export const clearDbById = (id) => {
    sessionStorage.remove(id);
}

/**
 * 会员类别 月季年转换
 * @param periodType
 * @returns {string}
 */
export const getVipTypeText = (periodType) => {
    return ['', '月', '季', '年'][periodType]
}

/**
 * 下单页
 * @param options
 */
export const openPlacePage = async (options = {}) => {
    if (redirect2Login()) return;
    // const res = await getLocationWhenHasPermission();
    // if (res) {
    //     console.error(res)
    //     options = {
    //         lat: res.latitude,
    //         lon: res.longitude,
    //         ...options,
    //     }
    // }

    router.navigateTo({
        name: 'placeOrder',
        query: {
            from: config.client,
            ...options
        }
    })

    // router.navigateTo({
    //     name: 'h5',
    //     query: {
    //         url: encodeUrl(config.h5.placePath),
    //         query: JSON.stringify({ from: config.client, ...options })
    //     }
    // })
}

/**
 * 普通订单详情页
 * @param options
 * @param jumpName
 */
export const openOrderDetail = (options, jumpName = 'navigateTo') => {
    router[jumpName]({
        name: 'orderDetail',
        query: {
            from: config.client,
            ...options
        }
    })
}

/**
 * 助理订单详情页
 * @param options
 * @param jumpName
 */
export const openWaiterOrderDetail = (options, jumpName = 'navigateTo') => {
    router[jumpName]({
        name: 'waiterOrderDetail',
        query: {
            from: config.client,
            ...options,
        }
    })
}

/**
 * 邀请赚钱
 */
export const openInviteMoneyPage = () => {
    router.navigateTo({
        name: 'inviteMoney',
        // query: {
        //     url: encodeUrl(config.h5.inviteMoneyPath),
        //     query: JSON.stringify({ from: config.client })
        // }
    })
}

/**
 * 会员页
 */
export const openVipPage = () => {
    router.navigateTo({
        name: 'vipIndex',
    })
}

/**
 * 服务列表页
 */
export const openServerListPage = (options, jumpName = 'navigateTo') => {
    router.navigateTo({
        name: 'serverList',
    })
}

/**
 * 我的钱包
 */
export const openMyWalletPage = () => {
    router.navigateTo({
        name: 'h5',
        query: {
            url: encodeUrl(config.h5.myWalletPath),
            query: JSON.stringify({ from: config.client })
        }
    })
}

/**
 * 会员卡赠送记录
 */
export const openVipShareCardRecordPage = () => {
    router.navigateTo({
        name: 'h5',
        query: {
            url: encodeUrl(config.h5.vipShareCardRecordPath),
            query: JSON.stringify({ from: config.client })
        }
    })
}

/**
 * 发单下单页
 * @param options
 */
export const openBillPlacePage = async (options = {}) => {
    if (redirect2Login()) return;
    // const res = await getLocationWhenHasPermission();
    // if (res) {
    //     console.error(res)
    //     options = {
    //         lat: res.latitude,
    //         lon: res.longitude,
    //         ...options,
    //     }
    // }
    router.navigateTo({
        name: 'billPlace',
        query: options
    })
}

/**
 * 助理报名
 */
export const grabOrdersEnroll = async (orderId, f = null) => {
    const query = getCurrPageQuery();
    let location = {
        latitude: query.lat || '',
        longitude: query.lon || ''
    };
    if (isWxH5()) {
        location = await getLocationWhenHasPermission()
    }
    const res = await appointApply({
        appointOrderId: orderId + '',
        lon: _get(location, 'longitude', ''),
        lat: _get(location, 'latitude', ''),
    });
    if (!res.$success) {
        showToast(_get(res, 'message', '服务器繁忙~'))
        f && f(res);
        return;
    }
    await showToastAsync('报名成功', { custom: 'success' })
    return true;
}

/**
 * 助理取消报名
 */
export const grabOrdersUnEnroll = async (orderId) => {
    // const location = await getLocationWhenHasPermission();
    const res = await appointCancelApply({
        appointOrderId: orderId + '',
        // lon: _get(location, 'longitude', ''),
        // lat: _get(location, 'latitude', ''),
    });
    if (!res.$success) return;
    await showToastAsync('已取消报名', { custom: 'success' })
    return true;
}

/**
 * 会员卡赠送规则
 */
export const openVipShareCardRulePage = () => {
    router.navigateTo({
        name: 'h5',
        query: {
            url: encodeUrl(config.h5.vipShareCardRulePath),
            query: JSON.stringify({ from: config.client })
        }
    })
}

/**
 * 校验当前模板id是否已经订阅，入参 id 数组
 * @param ids
 * @returns {Promise<unknown>}
 */
export const authSubscribeMessage = (ids) => {
    return new Promise(resolve => {
        // #ifdef MP-WEIXIN
        const statusF = (status) => {
            return ids.map(n => {
                return {
                    status,
                    id: n,
                }
            })
        }

        console.log('订阅消息模板id', ids)

        // status
        // reject 拒绝
        // accept 允许
        // unknown 未知
        wx.getSetting({
            withSubscriptions: true,
            success: (res) => {
                console.log('订阅消息权限判断：', res)
                const itemSettings = res.subscriptionsSetting.itemSettings;
                resolve(ids.map(n => {
                    return {
                        status: _get(itemSettings, `${n}`, 'unknown'),
                        id: n,
                    }
                }));
            },
            fail: (e) => {
                console.error(e);
                resolve(statusF(-1))
            }
        })
        // #endif

        // #ifdef H5
        resolve([])
        // #endif
    })
}

/**
 * 订阅消息
 */
export const subscribeMessage = (tmplIds = []) => {
    return new Promise(resolve => {
        // #ifdef MP-WEIXIN
        uni.requestSubscribeMessage({
            tmplIds,
            success: (res) => {
                console.log(res)
            },
            complete: () => {
                resolve()
            }
        })
        // #endif
        // #ifdef H5
        resolve()
        // #endif
    })
}

/**
 * 通过锻炼key 获取真实数据
 * @param shortKey
 * @returns {Promise<any|null>}
 */
export const getShortKeyData = async (shortKey) => {
    const res = await clientParamData(shortKey);
    if (!res.$success) {
        return null;
    }
    try {
        return JSON.parse(res.data.data)
    } catch (e) {
        console.error(e);
        return null
    }
}

export const getAppClientConfig = (key) => {
    if (!key) {
        return window.clientConfig || {}
    }
    return (window.clientConfig || {})[key]
}

/**
 * 初始化客户端信息
 * @param e
 */
export const initClientByQuery = (e) => {
    try {
        const info = {
            client: _get(e, 'query.from', getAppClientConfig('from') || config.client),
            app: false,
            ios: false,
            xapp: false,
            wxH5: false,
            // model 审核模式
            model: _get(e, 'query.model', 1) * 1,
        }
        info[info.client] = true;

        console.error('H5宿主环境：', JSON.stringify(info));
        console.error('客户端注入：', getAppClientConfig());


        sessionStorage.set('clientPlatform', info.client);

        const accessToken = getAppClientConfig('token') || e.query.token || '';

        let _op = {};
        if (accessToken) {
            _op.accessToken = accessToken;
        }

        // from app 安卓、 xapp 小程序 、 ios 苹果
        userInfoStore.setUserInfo({
            ...info,
            ..._op,
        })
    } catch (e) {

    }
}

export const isApp = () => {
    try {
        return userInfoStore.userInfo.app || (sessionStorage.get('clientPlatform') === 'app')
    } catch (e) {
        return null
    }
}


export const isIos = () => {
    try {
        return userInfoStore.userInfo.ios || (sessionStorage.get('clientPlatform') === 'ios')
    } catch (e) {
        return null
    }
}

export const isXapp = () => {
    try {
        return userInfoStore.userInfo.xapp || sessionStorage.get('clientPlatform') === 'xapp'
    } catch (e) {
        return null
    }
}

export const isWxH5 = () => {
    try {
        return userInfoStore.userInfo.wxH5 || (sessionStorage.get('clientPlatform') === 'wxH5')
    } catch (e) {
        return null
    }
}

/**
 * 获取app或小程序传来的参数
 * @returns {*&{token: *}}
 */
export const getQueryByWxAndApp = () => {
    try {
        const router = getCurrPageRoute();

        const routerQuery = {
            ...router.query,
        };

        // 缓存经纬度
        if (routerQuery.lat) {
            userInfoStore.setUserInfo({
                lat: routerQuery.lat,
                lon: routerQuery.lon
            })
        }

        return routerQuery
    } catch (e) {
        console.error(e)
        return {}
    }
}

/**
 * 是否获取模式
 * @returns {*|null}
 */
export const isAuditModel = () => {
    try {
        return userInfoStore.userInfo.model * 1 === 0
    } catch (e) {
        return null
    }
}
